<template>
<div id="contents" v-if="grid_layout_status == 'grid_list_show' && modal_show == false && modal_change == false">

  <div id="post_main">
    <div class="post_modal_window">
      <div id="grid_list">
        <div class="post_container" v-show="modal_show == false && post_type == 'all'">
          <div class="list_wrapper" v-for="(grid_list, index) in grid_all_lists" :key="index">
            <div class="left_list">
              <div v-for="(post, index) in grid_list.left_list"
                :key="index"
                :class="[grid_layout_status] + ' grid_list item ' + [index < 2 ? 'tmb_medium' : 'tmb_large' ]"
                @click="open_model(post.post_id, post.layout, post.link)"
                :style="{ 
                  'animation-duration': 1.4 - index / 10 + 's',
                  'animation-delay': 0.8 + index / 10 + 's'
                }">
                <div class="post_title" v-if="post.layout != 'program' && post.tag != '採用ムービー'" :class="title_color(post.layout)">
                  <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                </div>
                <img v-if="post.layout != 'players'" :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                <img v-else :src="post.kv_image" width="286" alt="番組のロゴ" class="hover players_kv" />
              </div>
            </div>

            <div class="right_list">
              <div v-for="(post, index) in grid_list.right_list"
                :key="index" 
                :class="[grid_layout_status] + ' grid_list item tmb_small'"
                @click="open_model(post.post_id, post.layout, post.link)"
                :style="{ 
                  'animation-duration': 1.4 - index / 10 + 's',
                  'animation-delay': 0.8 + index / 10 + 's'
                }">
                <div class="post_title" v-if="post.layout != 'program' && post.tag != '採用ムービー'" :class="title_color(post.layout)">
                  <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                </div>
                <img v-if="post.layout != 'players'" :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                <img v-else :src="post.kv_image" width="286" alt="番組のロゴ" class="hover players_kv" />
              </div>
            </div>
            <div :id="'add_grid_list_target_' + index " style="position: absolute, bottom: 0"></div>
          </div>
        </div>

        <div class="post_container" v-show="modal_show == false && post_type != 'all'">
          <div class="normal_list_wrapper" v-for="(grid_list, index) in grid_lists" :key="index">
            <div class="normal_list">
              <div v-for="(post, index) in grid_list"
                :key="index" 
                :class="[grid_layout_status] + ' grid_list item tmb_normal'"
                @click="open_model(post.post_id, post.layout, post.link)"
                :style="{ 
                  'animation-duration': 1.4 - index / 10 + 's',
                  'animation-delay': 0.01 + index / 10 + 's'
                }">
                <div class="post_title" v-if="post.layout != 'program' && post.tag != '採用ムービー'" :class="title_color(post.layout)">
                  <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                </div>
                <img v-if="post.layout != 'players'" :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                <img v-else :src="post.kv_image" width="286" alt="番組のロゴ" class="hover players_kv" />
              </div>
            </div>
            <div :id="'add_grid_list_target_' + index " style="position: absolute, bottom: 0"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_tags',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/recruit/recruit_2023.php',
      api_players_url: this.$parent.api_base_url+'/api/players/index.php',
      api_program_url: this.$parent.api_base_url+'/api/program/index.php',
      api_top_program_url: this.$parent.api_base_url+'/api/top/top_program.php',
      api_request_post_url: this.$parent.api_base_url+'/api/recruit/recruit_2023_request_post.php',
      api_base_url: this.$parent.api_base_url,
      loading: false,
      grid_lists: [],
      grid_all_lists: [],
      grid_lists_size: null,
      get_grid_list: [],
      past_get_grid_list: [],
      grid_list: null,
      players_list: null,
      top_program_list: null,
      recruit_2021_list: null,
      all_players_list: [],
      all_top_program_list: null,
      all_recruit_2021_list: null,
      error: null,
      modal: false,
      moving_speed: 12,
      back_btn: "back_hidden",
      request_layout: "",
      list_show_status: 'list_show',
      add_grid_timeout: false,
      add_grid_list_count: null,
      fetch_all_list_timeout: false,
      before_num: [],
      first_grid_lists: true,
      slice_players_list: [],
      slice_top_program_list: [],
      slice_recruit_2021_list: [],
      add_grid_list_stop: false,
    }
  },
  props: [
    'grid_layout_status',
    'modal_show',
    'modal_change',
    'post_type',
    'api',
    'request_id'
  ],
  watch: {
    grid_layout_status: function(){
      if ( this.grid_layout_status == 'grid_list_show' ){
        this.first_grid_lists = true
        this.grid_lists_size = null
        this.add_grid_list_count = 0
        this.grid_lists = []
        this.get_grid_list = []
        if( this.post_type == 'all'){
          if( this.grid_all_lists.length == 0){
            this.fetch_players_list(30)
            this.fetch_players_list(31)
            this.fetch_players_list(27)
            this.fetch_players_list(32)
            this.fetch_top_program_list(0)
            this.fetch_recruit_2021_list(null, null)
          } else {
            this.grid_all_lists = []
            this.fetch_all_list( this.all_players_list, this.all_top_program_list, this.all_recruit_2021_list )
          }
        } else if ( this.api == "players") {
          if (this.request_id == 0 && this.all_players_list){
            this.grid_list = []
            this.grid_list = this.grid_list.concat(this.all_players_list)
            for (let i = 0; i < this.grid_list.length; i++) {
              if ([8010, 8697, 7678].includes(this.grid_list[i].post_id)) {
                this.grid_list.splice(i--, 1);
              }
            }
            this.slice_grid_list()
          } else {
            this.fetch_players_list(this.request_id)
          }
        } else if ( this.api == "program") {
          if( this.request_id == 0){
            this.fetch_top_program_list(this.request_id)
          } else{
            this.fetch_program_list(this.request_id)
          }
        } else {
          this.fetch_recruit_2021_list(this.post_type, this.request_id)
        }
      } else {
        this.grid_lists = []
        this.get_grid_list = []
      }
    }
  },
  mounted () {
    this.fetch_players_list(30)
    this.fetch_players_list(31)
    this.fetch_players_list(27)
    this.fetch_players_list(32)
    this.fetch_top_program_list(0)
    this.fetch_recruit_2021_list(null, null)
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  created() {
    window.addEventListener('scroll', this.add_grid_list)
  },
  destroyed() {
    window.removeEventListener('scroll', this.add_grid_list)
  },
  methods: {
    open_model(post_id, layout, link) {
      this.$emit('modal_show', post_id, layout, link);
    },
    close_model() {
      this.$emit('modal_show');
    },
    grid_list_reload(post_type){
      var post_type = post_type.shift()
      this.$emit('request_post_type', post_type);
    },
    fetch_players_list(request_id){
      this.$axios
        .get(this.api_players_url,{
          params: {
            term_id: request_id
          }
        })
        .then(response => {
          this.grid_list = response.data.item
          if(request_id == 0){
            for (let i = 0; i < this.grid_list.length; i++) {
              if ([8010, 8697, 7678].includes(this.grid_list[i].post_id)) {
                this.grid_list.splice(i--, 1);
              }
            }
          }
          for ( var i = 0; i < this.grid_list.length; i++ ) {
            this.grid_list[i]['layout'] = "players"
            var name = this.grid_list[i]['name']
            this.grid_list[i]['name'] = []
            if (request_id == 30){
              this.grid_list[i]['name'].push('プロデューサー');
            } else if (request_id == 31) {
              this.grid_list[i]['name'].push('総合演出');
            } else if (request_id == 27) {
              this.grid_list[i]['name'].push('ディレクター');
            } else if (request_id == 32) {
              this.grid_list[i]['name'].push('カメラマン');
            }
            this.grid_list[i]['name'].push(name);
          }
          if (this.post_type == "all"){
            this.all_players_list = this.all_players_list.concat(this.grid_list)
          } else {
            this.slice_grid_list()
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    fetch_program_list(request_id){
      this.$axios
        .get(this.api_program_url,{
          params: {
            term_id: request_id
          }
        })
        .then(response => {
          this.grid_list = response.data.item
          for ( var i = 0; i < this.grid_list.length; i++ ) {
            this.grid_list[i]['layout'] = "program"
          }
          this.slice_grid_list()
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    fetch_top_program_list(){
      this.$axios
        .get(this.api_request_post_url,{
          params: {
            category: 'top_program',
          }
        })
        .then(response => {
          this.grid_list = response.data.item
          for ( var i = 0; i < this.grid_list.length; i++ ) {
            this.grid_list[i]['layout'] = "program"
          }
          if (this.post_type == "all"){
            this.all_top_program_list = this.grid_list
          } else {
            this.slice_grid_list()
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    fetch_recruit_2021_list(post_type, request_id){
      this.$axios
        .get(this.api_url,{
          params: {
            post_type: post_type
          }
        })
        .then(response => {
          this.grid_list = response.data.item
          for ( var i = 0; i < this.grid_list.length; i++ ) {
            this.grid_list[i].name.split('<p>').join('')
            this.grid_list[i].name = this.grid_list[i].name.split('<p>').join('')
            this.grid_list[i].name = this.grid_list[i].name.split('</p>').join('*')
            this.grid_list[i].name = this.grid_list[i].name.split('*');
            this.grid_list[i].name.pop();
          }
          if (request_id != null){
            this.fetch_request_post_list(request_id)
          } else if (this.post_type == "all"){
            this.all_recruit_2021_list = this.grid_list
            for(var i in this.all_recruit_2021_list){
              if([9170, 9467, 9468].includes(this.all_recruit_2021_list[i].id) ){
                this.all_recruit_2021_list.splice(i--, 1);
              }
            }
            clearTimeout( this.fetch_all_list_timeout );
            this.fetch_all_list_timeout = setTimeout(() => {
              this.fetch_all_list( this.all_players_list, this.all_top_program_list, this.all_recruit_2021_list )
            }, 500)
          } else {
            this.slice_grid_list()
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    fetch_request_post_list(request_id){
      this.$axios
        .get(this.api_request_post_url,{
          params: {
            request_id: request_id
          }
        })
        .then(response => {
          for ( var i = 0; i < response.data.item.length; i++ ) {
            if (this.post_type == 'drone'){
              response.data.item[i]['layout'] = "players"
              response.data.item[i]['name'] = ['カメラマン', response.data.item[i]['name']]
            } else {
              if (response.data.item[i]['layout'] == false){
                response.data.item[i]['layout'] = "pink"
              }
              response.data.item[i]['name'] = [response.data.item[i]['name']]
            }
          }
          this.grid_list = this.grid_list.concat(response.data.item)
          this.slice_grid_list()
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    list_shuffle(post_list){
      for(var list_size = post_list.length - 1; list_size > 0; list_size--){
        var r = Math.floor(Math.random() * (list_size + 1));
        var tmp = post_list[list_size];
        post_list[list_size] = post_list[r];
        post_list[r] = tmp;
      }
      return post_list
    },
    slice_all_list(slice_post_list, post_list, slice_size ,post_type){
      if (slice_post_list.length < slice_size && this.first_grid_lists == false && post_type == 'recruit_2021'){
        this.add_grid_list_stop = true
      } else {
        if(slice_post_list.length < slice_size ){
          slice_post_list = []
          slice_post_list = slice_post_list.concat(post_list)
          var past_post_id_list = []
          for(var i in this.past_get_grid_list){
            if (this.past_get_grid_list[i].id == undefined){
              past_post_id_list.push(this.past_get_grid_list[i].post_id)
            } else {
              past_post_id_list.push(this.past_get_grid_list[i].id)
            }
          }
          // for(var i in slice_post_list){
          //   if(past_post_id_list.includes(slice_post_list[i].id) ){
          //     slice_post_list.splice(i--, 1);
          //   }
          //   if(past_post_id_list.includes(slice_post_list[i].post_id) ){
          //     slice_post_list.splice(i--, 1);
          //   }
          // }
        }
      }
      this.get_grid_list = this.get_grid_list.concat(this.list_shuffle(slice_post_list).slice(0, slice_size));
      slice_post_list.splice(0, slice_size)
      return slice_post_list
    },
    fetch_all_list(players_list, top_program_list, recruit_2021_list){
      this.past_get_grid_list = []
      this.past_get_grid_list = this.past_get_grid_list.concat(this.get_grid_list)
      this.get_grid_list = [];
      if (this.first_grid_lists == false ){
        this.slice_players_list = this.slice_all_list(this.slice_players_list, players_list, 1, 'players')
        this.slice_top_program_list = this.slice_all_list(this.slice_top_program_list, top_program_list, 2, 'top_program')
        this.slice_recruit_2021_list = this.slice_all_list(this.slice_recruit_2021_list, recruit_2021_list, 4, 'recruit_2021')
      } else {
        this.slice_recruit_2021_list = []
        this.slice_recruit_2021_list = this.slice_recruit_2021_list.concat(recruit_2021_list)
        this.slice_players_list = this.slice_all_list(this.slice_players_list, players_list, 1, 'players')
        this.slice_top_program_list = this.slice_all_list(this.slice_top_program_list, top_program_list, 1, 'top_program')
        this.slice_recruit_2021_list = this.slice_all_list(this.slice_recruit_2021_list, recruit_2021_list, 2, 'recruit_2021')
        for(var i in this.slice_recruit_2021_list){
          if([9170, 9467, 9468].includes(this.slice_recruit_2021_list[i].id) ){
            this.slice_recruit_2021_list.splice(i--, 1);
          }
        }
      }
      for(var list_size = this.get_grid_list.length - 1; list_size > 0; list_size--){
        var r = Math.floor(Math.random() * (list_size + 1));
        var tmp = this.get_grid_list[list_size];
        this.get_grid_list[list_size] = this.get_grid_list[r];
        this.get_grid_list[r] = tmp;
      }
      var grid_list = [];
      if (this.first_grid_lists){
        for(var i in this.get_grid_list){
          if([9170, 9467, 9468].includes(this.get_grid_list[i].id) ){
            this.get_grid_list.splice(i--, 1);
          }
        }
        grid_list['left_list'] = this.get_grid_list.slice(0,2);
        var welfare_post = {"post_id":"","name":["福利厚生と働く環境"],"post_type":"welfare","link":"","tag":"福利厚生と働く環境","layout":"welfare","kv_image":"https:\/\/www.tv-asahipro.co.jp\/wp-content\/uploads\/2020\/03\/teaching-e1583916364211.png","kv_image_type":"normal"}
        grid_list['left_list'].unshift(welfare_post)
      } else {
        grid_list['left_list'] = this.get_grid_list.slice(0,3);
      }
      if (this.first_grid_lists){
        grid_list['right_list'] = this.get_grid_list.slice(2,4);
        var company_post = {"post_id":"","name":["会社のコト"],"post_type":"","link":"","tag":"会社のコト","layout":"company","kv_image":"https:\/\/www.tv-asahipro.co.jp\/wp-content\/uploads\/2020\/01\/company.png","kv_image_type":"normal"}
        var program_this_and_that_post = {"post_id":"","name":["番組制作のあれこれ"],"post_type":"program_this_and_that","link":"","tag":"番組制作のあれこれ","layout":"point","kv_image":"https:\/\/www.tv-asahipro.co.jp\/wp-content\/uploads\/2020\/01\/program_this_and_that_3.png","kv_image_type":"normal"}
        grid_list['right_list'].unshift(program_this_and_that_post)
        grid_list['right_list'].unshift(company_post)
        this.first_grid_lists = false
      } else {
        grid_list['right_list'] = this.get_grid_list.slice(3,7);
      }
      this.grid_all_lists.push(grid_list);
    },
    title_color(layout){
      if(['players', 'program', 'creator-agency', 'company', 'drone', 'photographing', 'link', 'pink' ,'rorando', 'welfare', 'working_environment', 'top_message', 'corona', 'galaxy_award' ].includes(layout) ){
        layout = 'pink'
      }
      return {
        pink: layout == 'pink',
        blue: layout == 'movie',
        purple: layout == 'young',
        yellow: layout == 'point',
        deep_blue: layout == 'pinch',
      }
    },
    slice_grid_list(){
      if (this.grid_lists_size == null){
        this.grid_lists_size = Math.ceil(this.grid_list.length / 9)
      }
      var grid_list = [];
      grid_list = this.grid_list.slice(0,9);
      this.grid_list.splice(0, 9)
      this.grid_lists.push(grid_list);
    },
    add_grid_list(){
      if (this.add_grid_list_count != null && this.modal_show == false && this.add_grid_list_stop == false) {
        clearTimeout( this.add_grid_timeout );
        if ( this.post_type == 'all' || this.grid_lists_size >= (this.add_grid_list_count + 2)) {
          this.add_grid_timeout = setTimeout(() => {
            var t = $('#add_grid_list_target_' + this.add_grid_list_count).offset().top;
            var p = t - $(window).height();
            if($(window).scrollTop() > p){
              if( this.post_type == 'all'){
                this.fetch_all_list( this.all_players_list, this.all_top_program_list, this.all_recruit_2021_list )
              } else {
                this.slice_grid_list()
              }
              this.add_grid_list_count++
            }else{
            }
          }, 300)
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">
@keyframes tag_slide_in
  0%
    display: block
  100%
    transform: translateY(0vw)

@keyframes tag_hidden
  0%
    opacity: 1
  20%
    opacity: 0
  21%
    transform: translateY(0vw)
  100%
    opacity: 0
    transform: translateY(100vw)
@keyframes tag_open
  0%
    opacity: 0
    transform: translateY(0vw)
  100%
    opacity: 1

@keyframes tag_choice
  0%
    width: auto
  100%
    top: 6.2vw
    left: 2.1vw
    width: auto
@keyframes tag_choice_text
  0%
  80%
    font-size: 5.1vw
  100%
    font-size: 5.1vw
@keyframes tag_return
  0%
    top: 6.2vw
    left: 2.1vw
    width: auto
  100%
@keyframes tag_return_text
  0%
    font-size: 5.1vw
  100%

.slide_in
  animation-name: tag_slide_in
  animation-fill-mode: forwards
  transform: translateY(70vw)

.choice
  animation-name: tag_choice
  animation-fill-mode: forwards
  animation-delay: 0s !important
  p
    animation-name: tag_choice_text
    animation-fill-mode: forwards
    animation-duration: 0.5s
    animation-delay: 0s !important

.show
  animation-name: tag_open
  animation-fill-mode: forwards
  animation-delay: 0s !important
  opacity: 0

.hidden
  animation-name: tag_hidden
  animation-fill-mode: forwards
  animation-duration: 0.2s
  animation-delay: 0s !important

.return
  animation-name: tag_return
  animation-fill-mode: forwards
  animation-duration: 2s
  animation-delay: 0s !important
  p
    animation-name: tag_return_text
    animation-fill-mode: forwards
    animation-duration: 0.5s
    animation-delay: 0s !important

@keyframes back_show
  0%
    opacity: 0
  100%
    opacity: 1
@keyframes back_hidden
  0%
    opacity: 1
  100%
    opacity: 0

.back_btn
  position: absolute
  top: 7.3vw
  left: 90.2vw
  font-family: 'Noto Sans JP', sans-serif
  font-weight: 700
  font-size: 1.6vw
  color: #FFF
  cursor: pointer
.back_show
  animation-name: back_show
  animation-fill-mode: forwards
  animation-duration: 2s
.back_hidden
  animation-name: back_hidden
  animation-fill-mode: forwards
  animation-duration: 1s

@keyframes grid_list_show
  0%
  100%
    transform: translateY(0vh)
@keyframes grid_list_hidden
  0%
    transform: translateY(0vh)
  100%
    transform: translateY(100vh)

.grid_list
  transform: translateY(100vh)
.grid_list_show
  animation-name: grid_list_show
  animation-fill-mode: forwards
  animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1)
.grid_list_hidden
  animation-name: grid_list_hidden
  animation-fill-mode: forwards
  animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1)
  animation-delay: 0s !important

#contents
  background-color: #ff7689
  min-height: 100vh
  overflow: hidden
.tag_list
  max-height: 56.9vw
  overflow: hidden
  position: relative
  &_item
    width: 5%
    display: flex
    position: absolute
    p 
      font-family: 'Noto Sans JP', sans-serif
      font-weight: 700
      line-height: 1
      color: #FFF
      display: block
      white-space: nowrap
      cursor: pointer

.post_container
  width: 96.2vw
  max-width: 1500px
  margin: 10.4vw auto 2.1vw
  position: relative
  .list_wrapper
    display: flex
    align-items: flex-start
    margin-bottom: 1.4vw
  .normal_list_wrapper
   display: flex
   align-items: flex-start
  &:after
    clear: both
    display: block
    content: ""
  .left_list
    display: flex
    flex-wrap: wrap
    width: 70vw
    .tmb_medium
      float: left
      width: 34.3vw
      height: 19.4vw
      max-width: 535px
      max-height: 302px
      .post_tag
        position: absolute
        top: 1.3vw
        right: 1vw
        height: 1.8vw
        background-color: #FF7689
        border-radius: 2vw
        z-index: 10
        padding: 0 0.7vw 0 0.7vw
        text-align: center
        p
          font-size: 0.8vw
          font-family: 'Noto Sans JP', sans-serif
          font-weight: 700
          line-height: 1.8vw
          color: #FFF
          cursor: pointer
          
      .post_title
        position: absolute
        bottom: 1.2vw
        z-index: 10
        p
          font-size: 1.6vw
          font-family: 'Noto Sans JP', sans-serif
          font-weight: 700
          line-height: 2.7vw
          margin-top: 0.3vw
          padding: 0 0.3vw 0 1.1vw
          display: table
          background-color: #FFF
          &:last-child
            padding-right: 0.5vw
      .pink
        font-size: 1.6vw
        font-family: 'Noto Sans JP', sans-serif
        font-weight: 700
        line-height: 2.7vw
        margin-top: 0.3vw
        padding: 0 0.8vw 0 0vw
        display: table
      &:nth-child(2)
        margin-left: 1.4vw
    .tmb_large
      float: left
      width: 70vw
      height: 39.4vw
      margin-top: 1.4vw
      max-width: 1092px
      max-height: 614px
      .post_tag
        position: absolute
        top: 2.1vw
        right: 2.4vw
        height: 1.8vw
        background-color: #FF7689
        border-radius: 2vw
        z-index: 10
        padding: 0 0.7vw 0 0.7vw
        text-align: center
        cursor: pointer
        p
          font-size: 0.8vw
          font-family: 'Noto Sans JP', sans-serif
          font-weight: 700
          line-height: 1.8vw
          color: #FFF
      .post_title
        position: absolute
        bottom: 2.5vw
        z-index: 10
        p
          font-size: 3.2vw
          font-family: 'Noto Sans JP', sans-serif
          font-weight: 700
          line-height: 4.2vw
          margin-top: 0.3vw
          padding: 0 0.4vw 0 1.5vw
          display: table
          background-color: #FFF
          &:last-child
            padding-right: 0.9vw
      .pink
        font-size: 3.2vw
        font-family: 'Noto Sans JP', sans-serif
        font-weight: 700
        line-height: 4.2vw
        margin-top: 0.3vw
        padding: 0 0.7vw 0 0vw
        display: table
  .right_list
    display: flex
    flex-wrap: wrap
    width: 24.8vw
    margin-left: 1.2vw
    .tmb_small
      float: left
      width: 24.8vw
      height: 13.8vw
      margin-top: 1.6vw
      .post_tag
        position: absolute
        top: 0.9vw
        right: 0.6vw
        height: 1.8vw
        background-color: #FF7689
        border-radius: 2vw
        z-index: 10
        padding: 0 0.7vw 0 0.7vw
        text-align: center
        p
          font-size: 0.8vw
          font-family: 'Noto Sans JP', sans-serif
          font-weight: 700
          line-height: 1.8vw
          color: #FFF
          cursor: pointer
      .post_title
        position: absolute
        bottom: 0.9vw
        z-index: 10
        p
          font-size: 1.1vw
          font-family: 'Noto Sans JP', sans-serif
          font-weight: 700
          line-height: 2vw
          margin-top: 0.3vw
          padding: 0 0.4vw 0 0.8vw
          display: table
          background-color: #FFF
          &:first-child
            margin-top: 0vw
          &:last-child
            padding-right: 0.4vw
      .pink
        font-size: 1.1vw
        font-family: 'Noto Sans JP', sans-serif
        font-weight: 700
        line-height: 2vw
        margin-top: 0.3vw
        padding: 0 0.4vw 0 0vw
        display: table
        &:first-child
          margin-top: 0vw
      &:first-child
        margin-top: 0vw
  .normal_list
    width: 95.9vw
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    &:after
      content: ""
      display: block
      width: 30.5vw
    .tmb_normal
      width: 30.5vw
      height: 16.8vw
      margin-bottom: 1.6vw
      .post_tag
        position: absolute
        top: 1.3vw
        right: 1vw
        height: 1.8vw
        background-color: #FF7689
        border-radius: 2vw
        z-index: 10
        padding: 0 0.7vw 0 0.7vw
        text-align: center
        p
          font-size: 0.8vw
          font-family: 'Noto Sans JP', sans-serif
          font-weight: 700
          line-height: 1.8vw
          color: #FFF
          cursor: pointer
      .post_title
        position: absolute
        bottom: 1.2vw
        z-index: 10
        p
          font-size: 1.6vw
          font-family: 'Noto Sans JP', sans-serif
          font-weight: 700
          line-height: 2.7vw
          padding: 0 0.3vw 0 1.2vw
          display: table
          background-color: #FFF
          &:not(:first-child)
            padding: 0 0.3vw 0 1.2vw
            margin-top: 0.3vw
      .pink
        font-size: 1.6vw
        font-family: 'Noto Sans JP', sans-serif
        font-weight: 700
        line-height: 2.7vw
        padding: 0 0.4vw 0 0
        display: table
        &:not(:first-child)
          margin-top: 0.3vw
  .item
    border-radius: 8px
    overflow: hidden
    position: relative
    background-color: #fff
    cursor: pointer
    img
      width: 101%
      overflow: hidden
      position: absolute
      top: 50%
      left: 50%
      cursor: pointer
    .kv
      -webkit-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
    .players_kv
      -webkit-transform: translate(-50%, -95%)
      transform: translate(-50%, -95%)
      animation: steps(5) infinite

#post
  &_main
    .post_modal_window
      .post_modal
        &_overlay 
          display: flex
          align-items: center
          justify-content: center
          position: fixed
          overflow: scroll
          z-index: 30
          top: 0
          left: 0
          width: 100%
          height: 100%
          z-index: 1000
          background: rgba(0, 0, 0, 0.5)
        &_window 
          background: #fff
          border-radius: 4px
          overflow: hidden
          height: 90%
        &_content
          height: 100%
          overflow: scroll

      .post_modal-enter-active, .post_modal-leave-active 
        transition: opacity 0.4s
        .post_modal_window 
          transition: opacity 0.4s, transform 0.4s

      .post_modal-leave-active 
        transition: opacity 0.6s ease 0.4s
      .modal-enter, .modal-leave-to 
        opacity: 0

        .post_modal
          &_window 
            opacity: 0
            transform: translateY(-20px)
          &_mask
            position: fixed
            z-index: 1000
            top: 0
            left: 0
            width: 100%
            height: 100%
            background-color: rgba(0, 0, 0, .5)
            display: table
            transition: opacity .3s ease

          &_wrapper 
            display: table-cell
            vertical-align: middle

          &_container 
            width: 300px
            margin: 0px auto
            padding: 20px 30px
            background-color: #fff
            border-radius: 2px
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33)
            transition: all .3s ease

.pink
  color: #FF7689
.blue
  color: #02ACC3
.purple
  color: #8B53AF
.yellow
  color: #FFBA00
.deep_blue
  color: #003A6F

.post_modal
  &_body 
    margin: 20px 0
  &_default-button 
    float: right
  &-enter 
    opacity: 0
  &-leave-active 
    opacity: 0

@media screen and (min-width:1500px)
  .post_container
    width: 1500px
    .list_wrapper
      height: 940px
      margin-bottom: 22px
    .normal_list_wrapper
      height: 859px
    .left_list
      width: 1092px
      .tmb_medium
        width: 535px
        height: 302px
        .post_title
          bottom: 18px
          p
            font-size: 24px
            line-height: 42px
            margin-top: 4px
            padding: 0 2px 0 11px
            &:last-child
              padding-right: 6px
        .pink
          font-size: 24px
          line-height: 42px
          margin-top: 4px
          padding: 0 7px 0 11px
        &:nth-child(2)
          margin-left: 21px
      .tmb_large
        width: 1092px
        height: 614px
        margin-top: 22px
        .post_title
          bottom: 39px
          p
            font-size: 50px
            line-height: 65px
            margin-top: 4px
            padding: 0 0 0 25px
            &:last-child
              padding-right: 14px
        .pink
          font-size: 50px
          line-height: 65px
          margin-top: 4px
          padding: 0 11px 0 25px
          &:last-child
            padding-right: 14px
    .right_list
      width: 386px
      margin-left: 18px
      .tmb_small
        width: 385px
        height: 216px
        margin-top: 25px
        &:first-child
          margin-top: 0px
        .post_title
          bottom: 15px
          p
            font-size: 17px
            line-height: 31px
            margin-top: 4px
            padding: 0 0 0 9px
            &:last-child
              padding-right: 5px
        .pink
          font-size: 17px
          line-height: 31px
          margin-top: 4px
          padding: 0 5px 0 9px
          &:last-child
            padding-right: 21px
    .normal_list
      width: 1500px
      &:after
        content: ""
        display: block
        width: 475px
      .tmb_normal
        width: 475px
        height: 262px
        margin-bottom: 24px
        .post_title
          position: absolute
          bottom: 1.2vw
          z-index: 10
          p
            font-size: 24px
            line-height: 42px
            padding: 0 4px 0 15px
            &:not(:first-child)
              margin-top: 4px
        .pink
          font-size: 24px
          line-height: 42px
          padding: 0 6px 0 17px
          &:not(:first-child)
            margin-top: 4px
</style>



// WEBPACK FOOTER //
// src/components/recruit_grid_list.vue